import { round } from "../number";
/**
 * Transform the y value for each series into a percentage of the total y values across all series at that point.
 */
export function percentageOfTotalTransformer(series) {
    const totalStat = sumStats(series);
    return series.map((innerSeries) => {
        return Object.assign(Object.assign({}, innerSeries), { stat: round(innerSeries.stat !== undefined ? (innerSeries.stat / totalStat) * 100 : 0, 1), metricType: "percentage", suffix: "%", data: innerSeries.data.map((point) => {
                const sum = sumValuesAtX(series, point.x);
                const percentage = point.y !== null && sum > 0 ? (point.y / sum) * 100 : 0;
                return Object.assign(Object.assign({}, point), { y: round(percentage, 1) });
            }) });
    });
}
function sumValuesAtX(series, x) {
    return series.reduce((sum, s) => { var _a; return sum + (((_a = s.data.find((p) => p.x === x)) === null || _a === void 0 ? void 0 : _a.y) || 0); }, 0);
}
function sumStats(series) {
    return series.reduce((sum, s) => sum + (s.stat || 0), 0);
}
